module.exports = __webpack_public_path__ + "media/images/icons/since-badge-fr-e2fa5ce467399f823503bcd4ceabec3f.svg";